<template>
    <div class="skill">
        <!-- <div class="heading2-section">
            References
        </div> -->
    <form>
        <div class="badges mb-3">
            
               <!-- badges -->
             <span class="badge bg-primary badge-container" v-for="reference in references" :key="reference.referenceId">
                <button class="badge-button" @click.prevent="reviewReference(reference)">{{reference.name}}</button>
                <button type="button" class="btn-close-white ms-2 badge-button-close" @click.prevent="deleteReference(reference)"><img class="icon" src="../../../assets/icons/close-outline.svg"></button>
            </span>   
            <!--  -->
            
        </div>
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input type="text" v-model="refedit.name" placeholder="Full Name" class="form-control">
        </div>
          <div class="mb-3">
            <label class="form-label">Company</label>
            <input type="text" v-model="refedit.company" placeholder="Name of Company" class="form-control">
        </div>
          <div class="mb-3">
            <label class="form-label">Position</label>
            <input type="text" v-model="refedit.position" placeholder="Their Position" class="form-control">
        </div>
          <div class="mb-3">
            <label class="form-label">Email Address</label>
            <input type="text" v-model="refedit.email" placeholder="Their Email Address" class="form-control">
        </div>
          <div class="mb-3">
            <label class="form-label">Phone</label>
            <input type="text" v-model="refedit.phone" placeholder="Their Phone" class="form-control">
        </div>       
         <div class="form-buttons mb-3">
            <div class="button-subgroup" v-if="isAdding">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Adding Reference...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="addReference()" v-else>Add Reference</button>
            </div>
            <div class="button-subgroup" v-else>
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Updating Reference...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="editReference()" v-else>Update Reference</button>
                <button type="submit" class="btn btn-default primary-btn badge-cancel"v-if="!loading && !buttonClicked" @click.prevent="cancel()">Cancel Edit</button>
            </div>
        </div>
         <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form>
     <LoadingIndicator v-if="loading"/>
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="referenceConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
</template>
<script>
import { addReferenceAsync,editReferenceAsync,deleteReferenceAsync } from '@/services/cvbuilderService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
export default {
    data(){
        return{
            isAdding: true,
            refedit:{
                name:"",
                company:"",
                position:"",
                email:"",
                phone:""
            },
             modal:{
                caption:"",
                message:""
            },
            selectedReferenceId:"",
            errors:[],
            loading:false,
            buttonClicked:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"addReference"   
        }
    },
    components:{
        LoadingIndicator,CustomConfirmationMessageModal
    },
    computed:{
        references(){
            var refs = this.$store.getters["cvbuilder/getCVInformation"]?.references || [];
            return refs;
        }            
    },
    methods:{
        reviewReference(reference){
            this.isAdding = false;
            this.refedit = {
                name: reference.name,
                position: reference.position,
                company: reference.company,
                email: reference.email,
                phone: reference.phone
            };
            this.selectedReferenceId = reference.referenceId
        },
        async deleteReference(reference){
            try{     
                this.resetOnBadgeSelection();
                var data = await deleteReferenceAsync(reference.referenceId);
                if(!data.success){
                    throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/removeReference",reference.referenceId);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.refedit = {
                                    name: "",
                                    position: "",
                                    company: "",
                                    email: "",
                                    phone: ""
                                };
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async addReference(){
            try{     
                var body = {
                    name: this.refedit.name,
                    company: this.refedit.company,
                    position: this.refedit.position,
                    email: this.refedit.email,
                    phone: this.refedit.phone
                }
                this.resetOnNewSubmit();   
                var data = await addReferenceAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/addNewReference", data.reference);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                     this.refedit = {
                                    name: "",
                                    position: "",
                                    company: "",
                                    email: "",
                                    phone: ""
                                };
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async editReference(){
            try{     
                 var body = {
                    name: this.refedit.name,
                    company: this.refedit.company,
                    position: this.refedit.position,
                    email: this.refedit.email,
                    phone: this.refedit.phone,
                    referenceId: this.selectedReferenceId
                }
                this.resetOnNewSubmit();   
                var data = await editReferenceAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/updateReference", body);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.refedit = {
                                    name: "",
                                    position: "",
                                    company: "",
                                    email: "",
                                    phone: ""
                                };
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        cancel(){
            this.isAdding = true;
            this.refedit = {
                name: "",
                position: "",
                company: "",
                email: "",
                phone: ""
            };
        },
         closeModal(){
        if (this.$refs.referenceConfirmModal && typeof this.$refs.referenceConfirmModal.hide === 'function') {
        this.$refs.referenceConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.referenceConfirmModal.show();
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.buttonClicked = true;
                this.hasErrors = false;
                this.errors = [];
        },
         resetOnBadgeSelection(){
                this.loading = true;
                //this.buttonClicked = true; //cause no form button is clicked
                this.hasErrors = false;
                this.errors = [];
        },
        clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }

        
    }
}
</script>
<style scoped>
    .badges{
        display:flex;
        flex-wrap: wrap;
        row-gap: 0.3rem;
        column-gap:0.3rem;
        /* border: 1px solid black; */
        width: 100%;
        
    }

    .badge{
        display: flex;
        align-items: center;
        border-radius: 100px;
        background-color: var(--primary)!important;
        padding-left: 1rem;
    }
</style>